export default V => [
  {
    path: '/transfers',
    component: V('transfers/Base'),
    children: [
      {
        name: 'transfers.list',
        path: '',
        component: V('transfers/List'),
        meta: {
          title: 'Transferências',
          breadcrumb: [{ title: 'Transferências' }],
        },
        // children: [
        //   {
        //     name: 'transfers.list.filter',
        //     path: 'filter',
        //     component: V('transfers/Filter'),
        //     meta: {
        //       title: 'Filtrar assinaturas',
        //       breadcrumb: [{ title: 'Assinaturas' }],
        //     },
        //   },
        // ],
      },
    ],
  },
]
